"use strict";

jQuery(document).ready(function ($) {
  var adpPopup = {};
  (function () {
    var $this;

    adpPopup = {
      sPrevious: window.scrollY,
      sDirection: "down",

      /*
       * Initialize
       */
      init: function (e) {
        $this = adpPopup;

        $this.popupInit(e);
        $this.events(e);

        // SEO/SEMANTIC FIX
        $this.seoInit();
      },

      /*
       * SEO init (runs once + keeps watching for dynamically injected banners)
       */
      seoInit: function () {
        // Run immediately
        $this.cleanSEO();
        $this.repositionCookieBanner();

        // Run again shortly after load (Shopify injecteert banner soms later)
        setTimeout(function () {
          $this.cleanSEO();
          $this.repositionCookieBanner();
        }, 500);

        setTimeout(function () {
          $this.cleanSEO();
          $this.repositionCookieBanner();
        }, 2000);

        // Observe DOM changes (best fix for late injections)
        $this.observeSEO();
      },

      /*
       * SEO FIX:
       * - Convert headings inside popups/age verification AND Shopify cookie banner to DIVs.
       * - Keeps classes/attributes so styling remains unchanged.
       * - Adds role="heading" + aria-level for accessibility.
       *
       * Goal: keep your page H1 as the first real heading for Google.
       */
      cleanSEO: function () {
        var selectors = [
          // Your popups
          ".popup h2, .popup h3, .popup h4, .popup h5, .popup h6",
          ".age-verification h2, .age-verification h3, .age-verification h4, .age-verification h5, .age-verification h6",

          // Shopify Customer Privacy banner (your screenshot confirms this)
          "#shopify-pc__banner h1, #shopify-pc__banner h2, #shopify-pc__banner h3, #shopify-pc__banner h4, #shopify-pc__banner h5, #shopify-pc__banner h6"
        ].join(", ");

        $(selectors).each(function () {
          var el = this;
          var tag = (el.tagName || "").toUpperCase();

          // Only convert headings
          if (!/^H[1-6]$/.test(tag)) return;

          var $heading = $(el);

          // Avoid re-processing if already converted
          if ($heading.attr("data-seo-fixed") === "true") return;

          // Copy all attributes (class/id/data-*)
          var attributes = {};
          $.each(el.attributes, function () {
            attributes[this.name] = this.value;
          });

          // Determine aria level from tag (H2 -> 2, etc.)
          var level = tag.replace("H", "");

          // Build replacement DIV
          var $div = $("<div />", attributes)
            .attr("role", "heading")
            .attr("aria-level", level)
            .attr("data-seo-fixed", "true")
            .html($heading.html());

          $heading.replaceWith($div);
        });
      },

      /*
       * DOM ORDER FIX:
       * Move Shopify cookie banner (#shopify-pc__banner) to end of <body>
       * so your main content (and H1) is earlier in the DOM.
       */
      repositionCookieBanner: function () {
        var $main = $("#MainContent");
        if (!$main.length) return;

        var banner = document.getElementById("shopify-pc__banner");
        if (!banner) return;

        // If banner is before main in the DOM, move it to end of body
        try {
          var precedesMain =
            banner.compareDocumentPosition($main[0]) & Node.DOCUMENT_POSITION_FOLLOWING;

          if (precedesMain) {
            document.body.appendChild(banner);
          }
        } catch (err) {
          // do nothing
        }
      },

      /*
       * Observe DOM injections and re-apply fixes
       */
      observeSEO: function () {
        if ($this._seoObserver) return; // prevent multiple observers

        $this._seoObserver = new MutationObserver(function () {
          $this.cleanSEO();
          $this.repositionCookieBanner();
        });

        $this._seoObserver.observe(document.body, { childList: true, subtree: true });
      },

      /*
       * Events
       */
      events: function () {
        $(document).on("click", ".popup-close", $this.closePopup);
        $(document).on("click", ".popup-accept", $this.acceptPopup);
        $(document).on("click", ".popup-accept", $this.closePopup);
        $(document).on("click", ".age-verification__popup-close", $this.agePopup);
        $(document).on("click", ".age-verification__popup-close", $this.closePopup);
        $(document).on("click", ".age-verification__button-no", $this.ageDeclined);

        $(document).keyup(function (e) {
          if (e.key === "Escape") {
            $(".popup-open[data-esc-close='true']").each(function (index, popup) {
              $this.closePopup(popup);
            });
          }
          if (e.key === "F4") {
            $(".popup-open[data-f4-close='true']").each(function (index, popup) {
              $this.closePopup(popup);
            });
          }
        });

        $(document).on("click", ".popup-overlay", function () {
          $(".popup-open[data-overlay-close='true']").each(function (index, popup) {
            $this.closePopup(popup);
          });
        });
      },

      /*
       * Init popup elements
       */
      popupInit: function () {
        $(document).on("scroll", function () {
          var scrollCurrent = window.scrollY;
          $this.sDirection = scrollCurrent > $this.sPrevious ? "down" : "up";
          $this.sPrevious = scrollCurrent;
        });

        $(".popup").each(function (index, popup) {
          if ("manual" === $(popup).data("open-trigger")) {
            var selector = $(popup).data("open-manual-selector");
            if (selector) {
              $(selector).addClass("popup-trigger");
              $(document).on("click", selector, function (e) {
                e.preventDefault();
                $(popup).removeClass("popup-already-opened");
                $this.openPopup(popup);
                if (e.currentTarget.classList.contains("popup")) {
                  $this.closePopup(selector);
                }
              });
            }
          }
          if (!$this.isAllowPopup(popup) && !$(popup).hasClass("age-verification")) {
            return;
          }
          $this.openTriggerPopup(popup);
        });
      },

      openTriggerPopup: function (e) {
        var popup = e && e.originalEvent ? this : e;
        var trigger = $(popup).data("open-trigger");

        if ("none" === trigger) {
          var ageVerification = $this.getStorage("popup-age-" + ($(popup).data("id") || 0));
          if (!ageVerification) $this.openPopup(popup);
        }

        if ("delay" === trigger) {
          setTimeout(function () {
            $this.openPopup(popup);
          }, $(popup).data("open-delay-number") * 1000);
        }

        if ("exit" === trigger) {
          var showExit = true;
          document.addEventListener("mousemove", function (e) {
            var scroll = window.pageYOffset || document.documentElement.scrollTop;
            if (e.pageY - scroll < 7 && showExit) {
              $this.openPopup(popup);
              showExit = false;
            }
          });
        }

        if ("scroll" === trigger) {
          var pointScrollType = $(popup).data("open-scroll-type");
          var pointScrollPosition = $(popup).data("open-scroll-position");
          $(document).on("scroll", function () {
            if ("px" === pointScrollType && window.scrollY >= pointScrollPosition) {
              $this.openPopup(popup);
            }
            if ("%" === pointScrollType && $this.getScrollPercent() >= pointScrollPosition) {
              $this.openPopup(popup);
            }
          });
        }

        if ("accept" === trigger) {
          var accept = $this.getStorage("popup-accept-" + ($(popup).data("id") || 0));
          if (!accept) $this.openPopup(popup);
        }
      },

      closeTriggerPopup: function (e) {
        var popup = e && e.originalEvent ? this : e;
        var trigger = $(popup).data("close-trigger");

        if ("delay" === trigger) {
          setTimeout(function () {
            $this.closePopup(popup);
          }, $(popup).data("close-delay-number") * 1000);
        }

        if ("scroll" === trigger) {
          var pointScrollType = $(popup).data("close-scroll-type");
          var pointScrollPosition = $(popup).data("close-scroll-position");
          var initScrollPx = $(popup).data("init-scroll-px");
          var initScrollPercent = $(popup).data("init-scroll-percent");

          $(document).on("scroll", function () {
            if ("px" === pointScrollType) {
              if ("up" === $this.sDirection && window.scrollY < initScrollPx - pointScrollPosition)
                $this.closePopup(popup);
              if ("down" === $this.sDirection && window.scrollY >= initScrollPx + pointScrollPosition)
                $this.closePopup(popup);
            }
            if ("%" === pointScrollType) {
              if (
                "up" === $this.sDirection &&
                $this.getScrollPercent() < initScrollPercent - pointScrollPosition
              )
                $this.closePopup(popup);
              if (
                "down" === $this.sDirection &&
                $this.getScrollPercent() >= initScrollPercent + pointScrollPosition
              )
                $this.closePopup(popup);
            }
          });
        }
      },

      openPopup: function (e) {
        var popup = e && e.originalEvent ? this : e;
        if ($(popup).hasClass("popup-open") || $(popup).hasClass("popup-already-opened")) return;

        if ($(popup).is("[data-body-scroll-disable='true']")) {
          $("body").addClass("popup-scroll-hidden");
        }

        var limit = parseInt($this.getStorage("popup-" + $(popup).data("id")) || 0, 10) + 1;
        $this.setStorage("popup-" + $(popup).data("id"), limit, {
          expires: $(popup).data("limit-lifetime"),
        });

        $(popup).addClass("popup-open");
        $(popup).data("init-scroll-px", window.scrollY);
        $(popup).data("init-scroll-percent", $this.getScrollPercent());

        $this.applyAnimation(popup, $(popup).data("open-animation"));
        $this.closeTriggerPopup(popup);
      },

      agePopup: function (e) {
        var $el = e && e.originalEvent ? this : e;
        var popup = $($el).closest(".popup");
        $this.setStorage("popup-age-" + $(popup).data("id"), 1, { expires: 360 });
      },

      ageDeclined: function () {
        $(".age-verification__question").removeClass("show");
        $(".age-verification__declined").addClass("show");
      },

      acceptPopup: function (e) {
        var $el = e && e.originalEvent ? this : e;
        var popup = $($el).closest(".popup");
        $this.setStorage("popup-accept-" + $(popup).data("id"), 1, { expires: 360 });
      },

      closePopup: function (e) {
        var $el = e && e.originalEvent ? this : e;
        var popup = $($el).closest(".popup");
        var animation = $(popup).data("exit-animation");

        $this.applyAnimation(popup, animation, function () {
          $(popup).addClass("popup-already-opened");
          $(popup).removeClass("popup-open");
        });
        $("body").removeClass("popup-scroll-hidden");
      },

      isAllowPopup: function (e) {
        var popup = e && e.originalEvent ? this : e;
        var limitDisplay = parseInt($(popup).data("limit-display") || 0, 10);
        var limitDisplayCookie = parseInt($this.getStorage("popup-" + $(popup).data("id")), 10);

        if (limitDisplay && limitDisplayCookie && limitDisplayCookie >= limitDisplay) return false;
        return true;
      },

      applyAnimation: function (el, name, callback) {
        var popup = $(el).closest(".popup");
        var overlayName = typeof callback === "function" ? "popupExitFade" : "popupOpenFade";

        $(popup)
          .next(".popup-overlay")
          .addClass("popup-animated " + overlayName)
          .one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function () {
            $(this).removeClass("popup-animated " + overlayName);
          });

        $(popup)
          .find(".popup-wrap")
          .addClass("popup-animated " + name)
          .one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function () {
            $(this).removeClass("popup-animated " + name);
            if (typeof callback === "function") callback();
          });
      },

      getStorage: function (key) {
        var item = localStorage.getItem(key);
        if (!item) return undefined;
        try {
          var parsed = JSON.parse(item);
          if (parsed.expires && Date.now() > parsed.expires) {
            localStorage.removeItem(key);
            return undefined;
          }
          return parsed.value;
        } catch (err) {
          return undefined;
        }
      },

      setStorage: function (key, value, options) {
        options = options || {};
        var data = { value: value, expires: null };
        if (options.expires) {
          var expiresDate = new Date();
          expiresDate.setDate(expiresDate.getDate() + parseInt(options.expires, 10));
          data.expires = expiresDate.getTime();
        }
        localStorage.setItem(key, JSON.stringify(data));
      },

      getScrollPercent: function () {
        var h = document.documentElement,
          b = document.body,
          st = "scrollTop",
          sh = "scrollHeight";
        return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
      },
    };
  })();

  adpPopup.init();

  document.addEventListener("shopify:section:load", function () {
    adpPopup.init();
  });

  document.addEventListener("shopify:section:unload", function () {
    $("body").removeClass("popup-scroll-hidden");
  });
});
